/**
 * Branch Service
 * Handles API calls for branch management (BASELINE_ENABLED structure)
 */

import { api } from "./apiService";
import { getStoredUser, getStoredClientId } from "../utils/tokenUtils";

export const branchService = {
  /**
   * Create a new branch from a baseline
   */
  createBranch: async (branchData) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      ...branchData,
      client_id: storedClientId || user?.client_id,
    };
    const response = await api.post("/branch/create", payload);
    return response.data;
  },

  /**
   * Get all branches for a project or baseline
   */
  getBranches: async (
    project_id,
    client_id,
    baseline_id = null,
    filters = {},
  ) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      project_id,
      client_id: client_id || storedClientId || user?.client_id,
      ...(baseline_id && { baseline_id }),
      ...filters,
    };
    const response = await api.post("/branch/list", payload);
    return response.data;
  },

  /**
   * Get branch by ID
   */
  getBranchById: async (branch_id, project_id, client_id) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      branch_id,
      project_id,
      client_id: client_id || storedClientId || user?.client_id,
    };
    const response = await api.post("/branch/get", payload);
    return response.data;
  },

  /**
   * Update a branch
   */
  updateBranch: async (branch_id, project_id, client_id, updates) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      branch_id,
      project_id,
      client_id: client_id || storedClientId || user?.client_id,
      ...updates,
    };
    const response = await api.post("/branch/update", payload);
    return response.data;
  },

  /**
   * Merge a branch into baseline
   */
  mergeBranch: async (branch_id, project_id, client_id) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      branch_id,
      project_id,
      client_id: client_id || storedClientId || user?.client_id,
    };
    const response = await api.post("/branch/merge", payload);
    return response.data;
  },

  /**
   * Close a branch
   */
  closeBranch: async (branch_id, project_id, client_id) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      branch_id,
      project_id,
      client_id: client_id || storedClientId || user?.client_id,
    };
    const response = await api.post("/branch/close", payload);
    return response.data;
  },

  /**
   * Delete a branch
   */
  deleteBranch: async (branch_id, project_id, client_id) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      branch_id,
      project_id,
      client_id: client_id || storedClientId || user?.client_id,
    };
    const response = await api.post("/branch/delete", payload);
    return response.data;
  },
};
